/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var FormRenderingStatus;
(function (FormRenderingStatus) {
    FormRenderingStatus[FormRenderingStatus["Success"] = 0] = "Success";
    FormRenderingStatus[FormRenderingStatus["NotFound"] = 1] = "NotFound";
    FormRenderingStatus[FormRenderingStatus["InternalServerError"] = 2] = "InternalServerError";
    FormRenderingStatus[FormRenderingStatus["EventCapacityIsFull"] = 100] = "EventCapacityIsFull";
    FormRenderingStatus[FormRenderingStatus["EventNotLive"] = 101] = "EventNotLive";
    FormRenderingStatus[FormRenderingStatus["FormNotLive"] = 102] = "FormNotLive";
    FormRenderingStatus[FormRenderingStatus["FormNotFound"] = 103] = "FormNotFound";
    FormRenderingStatus[FormRenderingStatus["FormPlaceholdersResolutionFailed"] = 104] = "FormPlaceholdersResolutionFailed";
    FormRenderingStatus[FormRenderingStatus["OperationCancelled"] = 105] = "OperationCancelled";
    FormRenderingStatus[FormRenderingStatus["EventWaitlisted"] = 106] = "EventWaitlisted";
})(FormRenderingStatus || (FormRenderingStatus = {}));
export var FormSubmitStatus;
(function (FormSubmitStatus) {
    FormSubmitStatus[FormSubmitStatus["Success"] = 0] = "Success";
    FormSubmitStatus[FormSubmitStatus["ValidationError"] = 1] = "ValidationError";
    FormSubmitStatus[FormSubmitStatus["InternalServerError"] = 2] = "InternalServerError";
    FormSubmitStatus[FormSubmitStatus["EventCapacityIsFull"] = 100] = "EventCapacityIsFull";
    FormSubmitStatus[FormSubmitStatus["EventNotLive"] = 101] = "EventNotLive";
    FormSubmitStatus[FormSubmitStatus["NoSessionsFound"] = 102] = "NoSessionsFound";
    FormSubmitStatus[FormSubmitStatus["SessionRegistrationRequired"] = 103] = "SessionRegistrationRequired";
    FormSubmitStatus[FormSubmitStatus["SessionValidationFailed"] = 104] = "SessionValidationFailed";
    FormSubmitStatus[FormSubmitStatus["SingleSessionRegistrationRequired"] = 105] = "SingleSessionRegistrationRequired";
    FormSubmitStatus[FormSubmitStatus["SessionCapacityIsFull"] = 106] = "SessionCapacityIsFull";
})(FormSubmitStatus || (FormSubmitStatus = {}));
var FormRenderingStatusIds = /** @class */ (function () {
    function FormRenderingStatusIds() {
    }
    FormRenderingStatusIds.EventAtCapacity = "eventAtCapacity";
    FormRenderingStatusIds.EventWaitlisted = "eventWaitlisted";
    return FormRenderingStatusIds;
}());
export { FormRenderingStatusIds };
var FormSuccessInformationStatusId = /** @class */ (function () {
    function FormSuccessInformationStatusId() {
    }
    FormSuccessInformationStatusId.None = "";
    FormSuccessInformationStatusId.SessionsFullyBookedEventHasCapacity = "sessionsFullyBookedEventHasCapacity";
    return FormSuccessInformationStatusId;
}());
export { FormSuccessInformationStatusId };
